import React from 'react';

const Register = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center p-8">
        <h1 className="text-2xl font-bold mb-4">Registration</h1>
        <p className="text-gray-600">
          The registration form has been replaced by Firebase Authentication.
        </p>
        <p className="mt-4">
          Please use the main login page to sign in with Google or Apple.
                        </p>
                    </div>
        </div>
    );
};

export default Register; 